import { GridComponentTypes, PageComponentTypes } from "@interfaces";

type ComponentMapType = {
    [key: string]: {
        label: string;
        icon: string;
        type: "both" | "job" | "page" | "legacy";
    };
};

export const ComponentMap: ComponentMapType = {
    [PageComponentTypes.TEXT]: {
        label: "Text",
        icon: "text_fields",
        type: "both",
    },
    [PageComponentTypes.CTA]: {
        label: "Call To Action Button",
        icon: "smart_button",
        type: "both",
    },
    [PageComponentTypes.GRID]: {
        label: "Grid",
        icon: "apps",
        type: "both",
    },
    [PageComponentTypes.HEADER]: {
        label: "Header",
        icon: "view_comfy",
        type: "page",
    },
    [PageComponentTypes.JOB_HEADER]: {
        label: "Job Header",
        icon: "view_comfy",
        type: "job",
    },
    [PageComponentTypes.IMAGE]: {
        label: "Image",
        icon: "image",
        type: "both",
    },
    [PageComponentTypes.IMAGE_TEXT]: {
        label: "Image With Text",
        icon: "art_track",
        type: "both",
    },
    [PageComponentTypes.JOBS]: {
        label: "Job",
        icon: "work",
        type: "both",
    },
    [PageComponentTypes.JOB_BOARD]: {
        label: "Job Listings",
        icon: "cases",
        type: "both",
    },
    [PageComponentTypes.JOB_BODY]: {
        label: "Job Body",
        icon: "read_more",
        type: "job",
    },
    [PageComponentTypes.JOB_SIDEBAR]: {
        label: "Job Sidebar",
        icon: "view_sidebar",
        type: "job",
    },
    [PageComponentTypes.MAP]: {
        label: "Map",
        icon: "map",
        type: "legacy",
    },
    [PageComponentTypes.QUOTE]: {
        label: "Quote",
        icon: "format_quote",
        type: "both",
    },
    [PageComponentTypes.VIDEO]: {
        label: "Video",
        icon: "ondemand_video",
        type: "both",
    },
    [PageComponentTypes.CAROUSEL]: {
        label: "Carousel",
        icon: "view_carousel",
        type: "both",
    },
    [PageComponentTypes.ACCORDION]: {
        label: "Accordion",
        icon: "bottom_panel_close",
        type: "both",
    },
    [PageComponentTypes.JD_MAIN_HEADER]: {
        label: "JD Main Header",
        icon: "view_comfy",
        type: "both",
    },
    [PageComponentTypes.JD_JOB_BODY]: {
        label: "JD Job Body",
        icon: "view_comfy",
        type: "both",
    },
    [PageComponentTypes.JD_LINK_GROUP]: {
        label: "JD Departments Grid",
        icon: "apps",
        type: "both",
    },
    [PageComponentTypes.BREADCRUMBS]: {
        label: "Breadcrumbs",
        icon: "format_list_bulleted",
        type: "both",
    },
    [PageComponentTypes.SOHO_SEARCH_BOX]: {
        label: "Soho Search Box",
        icon: "search",
        type: "both",
    },
    [PageComponentTypes.JD_PULLQUOTE]: {
        label: "JD Pullquote",
        icon: "format_quote",
        type: "both",
    },
    [PageComponentTypes.MEET_THE_TEAM]: {
        label: "Meet The Team",
        icon: "people",
        type: "page",
    },
};

export const GridComponentMap: ComponentMapType = {
    [GridComponentTypes.TEXT]: {
        label: "Text",
        icon: "text_fields",
        type: "both",
    },
    [GridComponentTypes.MAP]: {
        label: "Map",
        icon: "map",
        type: "legacy",
    },
    [GridComponentTypes.QUOTE]: {
        label: "Quote",
        icon: "format_quote",
        type: "both",
    },
    [GridComponentTypes.VIDEO]: {
        label: "Video",
        icon: "ondemand_video",
        type: "both",
    },
    [GridComponentTypes.IMAGE]: {
        label: "Image",
        icon: "image",
        type: "both",
    },
    [GridComponentTypes.JOB_DETAILS]: {
        label: "Job Details",
        icon: "fact_check",
        type: "job",
    },
    [GridComponentTypes.JOB_HEADER]: {
        label: "Job Header",
        icon: "view_comfy",
        type: "job",
    },
    [GridComponentTypes.JOB]: {
        label: "Job",
        icon: "work",
        type: "both",
    },
};

export const getPageOnlyPageComponents = (): ComponentMapType => {
    const retVal = {};

    for (let key in ComponentMap) {
        if (["page", "both"].includes(ComponentMap[key].type)) {
            retVal[key] = ComponentMap[key];
        }
    }

    return retVal;
};

export const getJobOnlyPageComponents = (): ComponentMapType => {
    const retVal = {};

    for (let key in ComponentMap) {
        if (["job", "both"].includes(ComponentMap[key].type)) {
            retVal[key] = ComponentMap[key];
        }
    }

    return retVal;
};

export const getPageOnlyGridComponents = (): ComponentMapType => {
    const retVal = {};

    for (let key in GridComponentMap) {
        if (["page", "both"].includes(GridComponentMap[key].type)) {
            retVal[key] = GridComponentMap[key];
        }
    }

    return retVal;
};

export const getJobOnlyGridComponents = (): ComponentMapType => {
    const retVal = {};

    for (let key in GridComponentMap) {
        if (["job", "both"].includes(GridComponentMap[key].type)) {
            retVal[key] = GridComponentMap[key];
        }
    }

    return retVal;
};
